import React from "react";
import { Container, Grid, Box, Typography } from "@mui/material";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Container>
        <Box
          sx={{
            border: 2,
            borderRadius: 5,
            padding: "50px 50px 50px 50px",
            mb: 2,
            mt: 15,
            bgcolor: "#1a193a",
          }}
        >
          <Grid container spacing={2}>
            <Grid item lg={4} md={6} xs={12}>
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: "1.1rem",
                  color: "white",
                  display: "flex",
                }}
              >
                <StorefrontIcon sx={{ color: "white", mr1: 1 }} /> Bella Store
              </Typography>
              <Typography sx={{ mt: 0.5, fontSize: "1.1rem", color: "white" }}>
                2024 Bella.All Right Reserved
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  mt: 1,
                  fontSize: "1.1rem",
                  color: "white",
                }}
              >
                <Link to="https://www.facebook.com/">
                  <FacebookOutlinedIcon sx={{ mr: 2,color:"white" }} />
                </Link>{" "}
                <Link to="https://twitter.com/">
                <TwitterIcon sx={{ mr: 2,color:"white"  }} />
                </Link>{" "}
                <Link to="https://www.instagram.com/">
                
                <InstagramIcon sx={{ mr: 2,color:"white"  }} />
                </Link>{" "}
                
              </Box>
            </Grid>
            <Grid item lg={4} md={6} xs={12}>
              <Typography
                onClick={() => navigate("/home")}
                sx={{ fontSize: "1.1rem", color: "white", cursor: "pointer" }}
              >
                Home
              </Typography>
              <Typography
                onClick={() => navigate("/about us")}
                sx={{ fontSize: "1.1rem", color: "white", cursor: "pointer" }}
              >
                About Us
              </Typography>
              <Typography
                onClick={() => navigate("/contact us")}
                sx={{ fontSize: "1.1rem", color: "white", cursor: "pointer" }}
              >
                Contact Us
              </Typography>
              <Typography
                onClick={() => navigate("/collection")}
                sx={{ fontSize: "1.1rem", color: "white", cursor: "pointer" }}
              >
                Collection
              </Typography>
            </Grid>
            <Grid item lg={4} md={6} xs={12}>
              <Typography sx={{ fontSize: "1.1rem", color: "white" }}>
                Contact Us
              </Typography>
              <Typography sx={{ fontSize: "1.1rem", color: "white" }}>
                011-025874
              </Typography>
              <Typography sx={{ fontSize: "1.1rem", color: "white" }}>
                bellastore@gmail.com
              </Typography>
              <Typography sx={{ fontSize: "1.1rem", color: "white" }}>
                www.bellastore.com.np
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default Footer;
